import { render, staticRenderFns } from "./ResourcesOverview.vue?vue&type=template&id=0b581708&scoped=true&"
import script from "./ResourcesOverview.vue?vue&type=script&lang=js&"
export * from "./ResourcesOverview.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesOverview.vue?vue&type=style&index=0&id=0b581708&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b581708",
  null
  
)

export default component.exports